export default __webpack_public_path__ + "static/media/admin_product_setting_active.e7ea7500.svg";